<template>
  <div class="ui left aligned container">
    <vuetable ref="vuetable"
              api-url="/owhat"
              :fields="fields"
              :sort-order="sortOrder"
              @vuetable:cell-clicked="onRowClicked"
              @vuetable:pagination-data="onPaginationData">
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>

    <div class="ui action input">
      <input type="number" v-model="id" @keypress.enter="load">
      <button class="ui button" @click="load">统计</button>
    </div>

    <div class="ui segment">
      <div class="ui active dimmer" v-if="loading">
        <div class="ui loader"></div>
      </div>
      <h3>基本信息</h3>
      <div class="ui grid" v-if="owhat">
        <div>
          <div>标题： <a target="_blank" :href="'https://m.owhat.cn/shop/shopdetail.html?id='+owhat.id">{{owhat.title}}</a>
          </div>
          <div>商家： <a target="_blank" :href="'https://m.owhat.cn/stars/fansclub.html?clubid='+owhat.ownerId">{{owhat.owner}}</a>
          </div>
          <div>已售： {{owhat.paystock}}件</div>
        </div>
        <div>
          <div>开始时间： {{owhat.salestartat | datetime}}</div>
          <div>结束时间： {{owhat.saleendat | datetime}}</div>
          <div>统计时间： {{owhat.time | datetime}}</div>
        </div>
        <div>
          <a target="_blank" :href="'https://m.owhat.cn/vowhat/dist/home.html#/starhome?userid='+item.id"
             v-for="item in owhat.stars" :key="item.id">
            <img class="ui avatar image" :src="item.avatar">
            <span>{{item.name}}</span>
          </a>
        </div>
      </div>

      <h3>统计信息</h3>
      <div class="ui grid" v-if="owhat">
        <div>
          <div>总金额： {{owhat.total}}</div>
          <div>人数： {{owhat.count}}</div>
        </div>
        <div>
          <div>最大值： {{owhat.max}}</div>
          <div>最小值： {{owhat.min}}</div>
        </div>
        <div>
          <div>中位数： {{owhat.median}}</div>
          <div>平均值： {{owhat.avg.toFixed(2)}}</div>
        </div>
      </div>

      <table class="ui selectable celled table" v-if="owhat">
        <thead>
        <tr>
          <th>名称</th>
          <th>金额</th>
          <th>数量</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in owhat.prices" :key="item.price">
          <td>{{item.name}}</td>
          <td>{{item.price}}</td>
          <td>{{item.count}}</td>
        </tr>
        </tbody>
      </table>

      <h3 v-if="owhat"><a target="_blank" :href="'https://m.owhat.cn/shop/toplist.html?id='+owhat.id">排行榜</a></h3>
      <table class="ui selectable celled table" v-if="owhat">
        <thead>
        <tr>
          <th>#</th>
          <th>名字</th>
          <th>金额</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in owhat.top" :key="index">
          <td>{{index+1}}</td>
          <td>{{item.name}}</td>
          <td>{{item.amount}}</td>
        </tr>
        <tr>
          <td></td>
          <td>总额</td>
          <td>{{top20.toFixed(2)}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import { datetime } from '../filters'

  export default {
    name: "Owhat",
    components: {
      Vuetable,
      VuetablePagination,
    },
    data() {
      return {
        id: null,
        loading: false,
        top20: 0,
        owhat: null,
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        fields: [
          {name: 'id', title: 'ID', sortField: 'id'},
          {name: 'title', title: '名称'},
          {name: 'owner', title: '商家'},
          {name: 'total', title: '总额', sortField: 'total'},
          {name: 'count', title: '人数', sortField: 'count'},
          {name: 'salestartat', title: '开始时间', sortField: 'salestartat', callback: 'time'},
          {name: 'saleendat', title: '结束时间', sortField: 'saleendat', callback: 'time'},
          {name: 'time', title: '统计时间', sortField: 'time', callback: 'time'},
        ],
      }
    },
    methods: {
      load() {
        if (this.id) {
          this.loading = true;
          axios.get('/owhat/' + this.id).then(({data}) => {
              this.loading = false;
              this.owhat = data;
              this.top20 = data.top.map(e => e.amount).reduce((accumulator, currentValue) => accumulator + currentValue);
            },
            (error) => {
              this.loading = false;
              this.owhat = null;
              console.log(error);
            });
        }
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.load();
        this.$refs.vuetable.changePage(page)
      },
      onRowClicked(data, field) {
        if (field.name === 'id') {
          this.id = data.id
          this.load()
        }
      },
      time(value) {
        return datetime(value)
      }
    }
  };
</script>

<style scoped>
  .ui.avatar.image {
    width: 4rem;
    height: 4rem;
  }
  .input {
    margin-top: 12px;
  }
</style>
